import { COLOURS } from './colours';
import { fontFamily } from './constants';
const styleOverrides = {
    root: Object.assign(Object.assign({}, fontFamily), { color: COLOURS.Black }),
};
export const MuiMenuItem = {
    styleOverrides,
};
